import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '../context/PermissionsContext';

const ProtectedRoute = ({ permission, children }) => {
    const { hasPermission, getPermissionId } = usePermissions();
    const location = useLocation();

    if (!hasPermission(permission)) {
        // Enviar el ID del permiso si no es admin, o un código genérico
        const permId = getPermissionId(permission) || permission;
        // Redirigir a access-denied enviando de dónde venía y qué permiso necesita
        return <Navigate to={`/access-denied?permiso=${permId}&from=${encodeURIComponent(location.pathname)}`} replace />;
    }

    return children;
};

export default ProtectedRoute;
